import LoadingAction from "@common/redux/actions/LoadingAction";
import { handleError } from "@common/components/helpers/error";
import ObservationsClient from "@common/api/ObservationsClient";
import { formatForSelect } from "./formOptions";
import ObservationsAction from "@common/redux/actions/ObservationsAction";
import CustomerClient from "@common/api/CustomerClient";

const fetchObservationsData = () => {
  LoadingAction.set(true).then(() => {
    CustomerClient.MetaData().then(
      (response) => {
        ObservationsAction.dispatch({
          customerRecord: { ...response.record },
        });
      },
      (error) => handleError(error),
    );

    ObservationsClient.MetaData()
      .then(
        (response) => {
          ObservationsAction.dispatch({
            observationOptions: formatForSelect(response.behaviours),
            moodOptions: formatForSelect(response.moods, true),
            record: { ...response.record },
          });
        },
        (error) => handleError(error),
      )
      .finally(() => LoadingAction.set(false));
  });
};

export default fetchObservationsData;
